import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceindelhiforindustrial() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Delhi for Industrial',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Delhi for Industrial',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Delhi for industrial sectors, catering to the transportation needs of factories, manufacturing units, warehouses, and industrial parks. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, managers, and visiting clients. Whether it is daily staff commute, plant visits, inter-office travel, airport transfers, or executive transportation, we deliver smooth and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for industrial businesses operating in and around Delhi.',

    top: 'Top Places to Visit in Delhi with Pune Corporate Car',

"topPlaces": [
  {
    "title": "India Gate",
    "description": "India Gate is a towering war memorial located at the heart of New Delhi, built to honor soldiers of the British Indian Army who died in World War I. Surrounded by wide lawns and beautiful avenues, it is a popular spot for picnics, evening walks, and photography. The Amar Jawan Jyoti, an eternal flame, adds a solemn and reflective atmosphere. Street vendors selling snacks, flowers, and souvenirs create a lively environment, especially during evenings and weekends."
  },
  {
    "title": "Red Fort",
    "description": "The Red Fort is a UNESCO World Heritage Site and a symbol of Mughal architecture in Delhi. Built in 1639 by Emperor Shah Jahan, the fort’s massive red sandstone walls, intricate carvings, and grand gates showcase the grandeur of the Mughal era. Visitors can explore Diwan-i-Aam, Diwan-i-Khas, and museums inside, while the fort hosts the annual Independence Day flag-hoisting ceremony, attracting thousands of spectators."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar is the tallest brick minaret in the world, standing at 73 meters, and a UNESCO World Heritage Site. Built in 1193, it features intricate Indo-Islamic architecture with inscriptions and carvings. The surrounding Qutub complex includes ancient tombs, mosques, and lush gardens, offering history enthusiasts a serene space for exploration, photography, and educational trips."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb is a magnificent Mughal mausoleum built in 1570, renowned for its Persian-style architecture and beautifully landscaped gardens. It is considered a precursor to the Taj Mahal and is a UNESCO World Heritage Site. The tomb’s symmetrical design, water channels, and tranquil environment make it an ideal spot for history lovers, photographers, and visitors seeking a peaceful retreat in Delhi."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple, also called the Bahá’í House of Worship, is famous for its lotus-shaped architecture and serene surroundings. Open to people of all faiths, it provides a peaceful environment for meditation, reflection, and spiritual exploration. The temple’s gardens, water pools, and quiet ambiance enhance the visitor experience, making it a unique spiritual and architectural landmark."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a modern cultural and spiritual complex showcasing traditional Indian architecture, art, and heritage. The sprawling site includes intricately carved stone temples, exhibitions on Indian history, musical fountains, and lush gardens. Visitors can explore the temple, attend cultural shows, and enjoy the evening light and sound display, offering both educational and spiritual experiences."
  },
  {
    "title": "Connaught Place",
    "description": "Connaught Place is New Delhi’s commercial and social hub, featuring colonial-era architecture, circular plazas, and bustling streets with shops, restaurants, and cafés. It is ideal for shopping, dining, nightlife, and people-watching. The central park hosts events and festivals, making it a lively and vibrant area that combines history, commerce, and leisure."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, one of India’s largest mosques, was built in 1656 by Emperor Shah Jahan. The mosque features grand red sandstone and marble architecture, spacious courtyards, and tall minarets. Visitors can climb the minarets for panoramic views of Old Delhi, explore the bustling surrounding bazaars, and experience the rich cultural and spiritual atmosphere of the area."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is the memorial dedicated to Mahatma Gandhi, marked by a simple black marble platform amidst serene gardens. It is a place of reflection, visited by people from across India and the world. The peaceful surroundings, eternal flame, and commemorative plaques make it a revered site for learning about Gandhi’s life and philosophy."
  },
  {
    "title": "Lodhi Gardens",
    "description": "Lodhi Gardens is a historic park blending natural beauty with architectural heritage. It features tombs from the Lodhi dynasty, landscaped gardens, walking and jogging paths, and tree-lined avenues. The park is a favorite spot for morning walkers, families, photographers, and tourists seeking a calm, scenic, and recreational environment in the midst of Delhi’s urban landscape."
  }
],


"services": [
{
"name": "Industrial Workforce Transport Delhi",
"description": "Industrial Workforce Transport Delhi provides large-scale, structured, and reliable mobility solutions for factory employees, assembly-line workers, warehouse staff, and blue-collar teams across all major industrial zones of Delhi. The service includes GPS-monitored fleets, professional drivers trained for industrial routes, shift-based operations, automated scheduling, and route optimization. Designed to support large manufacturing clusters, it ensures punctual, safe, and well-coordinated transportation for thousands of workers daily."
},
{
"name": "Factory Employee Shuttle Delhi",
"description": "Factory Employee Shuttle Delhi offers high-capacity shuttle services using minibuses, tempo travelers, and staff vans for seamless factory workforce commuting. With multi-shift operations, real-time tracking, safety monitoring, and industrial-area route expertise, the service supports smooth movement for workers employed in manufacturing plants, logistics hubs, and industrial estates across Delhi."
},
{
"name": "Worker Pickup Drop Delhi",
"description": "Worker Pickup Drop Delhi delivers dependable shift-based transportation tailored specifically for industrial and factory workers. Featuring structured routing, punctual shift alignment, safety-driven operations, and robust vehicle management, it ensures that employees reach factories, warehouses, and industrial facilities on time for every operational shift throughout the day and night."
},
{
"name": "Industrial Cab Delhi",
"description": "Industrial Cab Delhi provides reliable cab services designed for the unique needs of industrial companies, production units, and manufacturing facilities. With GPS-enabled sedans, SUVs, and multi-utility vehicles, the service supports supervisor movement, administrative staff travel, and industrial site-to-site commuting with professional chauffeurs and optimized routing."
},
{
"name": "Affordable Corporate Cabs Delhi Industrial",
"description": "Affordable Corporate Cabs Delhi Industrial offers cost-effective yet highly dependable transportation solutions for workforce mobility in factories and industrial operations. Featuring comfortable vehicles, trained drivers, GPS monitoring, and economical pricing plans, it is ideal for companies seeking safe, budget-friendly commuting for their employees."
},
{
"name": "Company Cab Delhi Industrial Zone",
"description": "Company Cab Delhi Industrial Zone provides reserved corporate cab services for factories, industrial parks, and large manufacturing units. With dedicated cabs, professional drivers, real-time monitoring, and tailored operational schedules, the service ensures smooth intra-zone travel for managers, supervisors, and administrative staff."
},
{
"name": "Monthly Industrial Transport Delhi",
"description": "Monthly Industrial Transport Delhi offers long-term, fixed-plan transportation solutions for businesses requiring continuous workforce commuting. Featuring monthly contracts, dedicated vehicles, real-time tracking, and shift-based operations, it ensures uninterrupted staff transport for industries operating 24/7 across the Delhi region."
},
{
"name": "Best Industrial Cabs Delhi",
"description": "Best Industrial Cabs Delhi delivers premium-quality industrial commuting solutions combining safety, efficiency, and professional management. With clean vehicles, trained industrial drivers, GPS supervision, and well-planned routes, it provides top-tier employee mobility for both small factories and large manufacturing clusters."
},
{
"name": "Outstation Industrial Cab Delhi",
"description": "Outstation Industrial Cab Delhi offers reliable intercity travel for factory teams, engineers, supervisors, and industrial management personnel. With long-distance-ready vehicles, skilled highway drivers, and 24/7 availability, the service supports business visits, plant inspections, raw material procurement trips, and multi-city industrial operations."
},
{
"name": "Sedan Industrial Cab Delhi",
"description": "Sedan Industrial Cab Delhi provides premium sedans for supervisors, engineers, managers, and visiting corporate executives who travel between industrial zones, warehouses, manufacturing sites, and offices. The service ensures punctual pickups, professional chauffeurs, comfortable seating, and safe travel experiences."
},
{
"name": "SUV Industrial Cab Delhi",
"description": "SUV Industrial Cab Delhi offers rugged and spacious SUVs ideal for team movement, plant-to-plant travel, factory inspections, and long-route industrial operations. With high-comfort seating, professional drivers, and enhanced safety features, the service supports both daily industrial mobility and long-distance business travel."
},
{
"name": "Business Transport Delhi Industrial",
"description": "Business Transport Delhi Industrial provides tailored mobility services for industrial executives, procurement teams, field engineers, and supervisors. It includes well-maintained sedans and SUVs, GPS-monitored trips, trained chauffeurs, and premium corporate travel standards designed specifically for industrial business needs."
},
{
"name": "Corporate Fleet Delhi Industrial",
"description": "Corporate Fleet Delhi Industrial delivers comprehensive fleet management solutions for large factories, industrial corporations, and multi-unit manufacturing setups. With sedans, SUVs, shuttles, and multi-capacity vehicles, plus automated rostering, maintenance management, and GPS tracking, it ensures fully controlled and efficient workforce mobility."
},
{
"name": "Staff Mobility Delhi Industrial",
"description": "Staff Mobility Delhi Industrial offers end-to-end mobility planning and transportation execution for industrial companies. The service includes optimized pickup-drop routes, trained drivers, shift-oriented scheduling, vehicle monitoring, and multi-zone coverage to ensure safe and consistent staff movement across factory hubs."
},
{
"name": "Factory Commute Delhi",
"description": "Factory Commute Delhi provides reliable, well-organized daily commuting solutions tailored for industrial workers, machine operators, and assembly-line staff. Featuring structured routing, multi-shift synchronization, experienced industrial drivers, and safe travel practices, it ensures smooth commute operations for factories across Delhi."
}
],

"tableData": [
["Industrial Workforce Transport Delhi", "Factory Employee Shuttle Delhi"],
["Worker Pickup Drop Delhi", "Industrial Cab Delhi"],
["Affordable Corporate Cabs Delhi Industrial", "Company Cab Delhi Industrial Zone"],
["Monthly Industrial Transport Delhi", "Best Industrial Cabs Delhi"],
["Outstation Industrial Cab Delhi", "Sedan Industrial Cab Delhi"],
["SUV Industrial Cab Delhi", "Business Transport Delhi Industrial"],
["Corporate Fleet Delhi Industrial", "Staff Mobility Delhi Industrial"],
["Factory Commute Delhi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Delhi for Industrial",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Delhi for industrial areas, ensuring smooth and efficient transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Reliable Pickups & Drop-offs",
    "WhyChoosedescription": "We offer timely pickups and drop-offs across major industrial zones in Delhi, ensuring workers and staff reach their workplaces without delays."
  },
  {
    "WhyChooseheading": "Experienced & Professional Drivers",
    "WhyChoosedescription": "Our trained and disciplined chauffeurs ensure safe, courteous, and comfortable travel for employees working in Delhi's industrial sectors."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Industrial Routes",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—clean, serviced, and reliable for regular commuting to industrial locations in Delhi."
  },
  {
    "WhyChooseheading": "Customized Industrial Travel Packages",
    "WhyChoosedescription": "We offer tailored cab rental solutions designed to meet the daily transportation needs of factories, plants, and industrial establishments in Delhi."
  },
  {
    "WhyChooseheading": "24/7 Support for Industrial Shifts",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for shift-based travel, emergency bookings, and last-minute adjustments across industrial routes."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, ensuring safe and hygienic rides for industrial workforce commuting."
  },
  {
    "WhyChooseheading": "Seamless Booking & Coordination",
    "WhyChoosedescription": "Industrial employee transportation becomes effortless with our streamlined booking system and reliable coordination for daily travel operations."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services for industrial areas in Delhi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services specifically designed for industrial zones across Delhi.',
  },
  {
    question: 'Which industrial areas in Delhi do you cover?',
    answer: 'We cover Okhla Industrial Area, Naraina Industrial Area, Mayapuri, Bawana Industrial Area, Narela, Patparganj Industrial Area, and more.',
  },
  {
    question: 'Do you support employee transportation for factories and industrial zones?',
    answer: 'Yes, we provide specialized employee transportation solutions for manufacturing units, warehouses, and industrial plants in Delhi.',
  },
  {
    question: 'How can companies book corporate cab services for industrial locations?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate transportation support team.',
  },
  {
    question: 'What vehicle options are available for industrial corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, and staff buses depending on workforce size and transportation needs.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for industrial companies?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual transportation contracts for industrial clients in Delhi.',
  },
  {
    question: 'Are your vehicles equipped with safety and tracking systems?',
    answer: 'All our vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs for maximum safety.',
  },
  {
    question: 'Do you provide cab services for multiple shifts in industrial units?',
    answer: 'Yes, we manage transportation for early morning, evening, night, and rotating industrial shifts.',
  },
  {
    question: 'What payment options are available for industrial corporate cab services?',
    answer: 'We offer UPI, bank transfers, credit/debit cards, digital wallets, and monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harish Ahuja',
    feedback: 'Excellent corporate cab service for our industrial unit in Delhi. Reliable, punctual, and driver behavior is very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sheetal Arora',
    feedback: 'Very dependable transportation service for our factory employees. Clean vehicles and seamless shift operations.',
    rating: 5,
  },
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Delhi for Industrial",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-delhi-industrial.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers specialized corporate cab services for industrial clients in Delhi, including workforce transport, factory employee shuttles, worker pickup & drop, monthly industrial cab plans, business transport, outstation industrial trips, and chauffeur-driven executive vehicles for companies operating in Delhi's industrial zones.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-delhi-industrial"
  }
};





  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Delhi for Industrial | Employee & Factory Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services for industrial clients in Delhi including workforce transport, factory employee shuttles, worker pickup & drop, industrial cabs, monthly transport plans, outstation trips, and chauffeur-driven vehicles for Delhi industrial zones."
  />

  <meta
    name="keywords"
    content="Industrial Workforce Transport Delhi, Factory Employee Shuttle Delhi, Worker Pickup Drop Delhi, Industrial Cab Delhi, Affordable Corporate Cabs Delhi Industrial, Company Cab Delhi Industrial Zone, Monthly Industrial Transport Delhi, Best Industrial Cabs Delhi, Outstation Industrial Cab Delhi, Sedan Industrial Cab Delhi, SUV Industrial Cab Delhi, Business Transport Delhi Industrial, Corporate Fleet Delhi Industrial, Staff Mobility Delhi Industrial, Factory Commute Delhi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceindelhiforindustrial;